import { createFileRoute } from '@tanstack/react-router'
import { UsersManagement } from '../../../components/AdminUsers/UsersManagement'

export const Route = createFileRoute('/admin/users/')({
  component: () => <UsersManagement />,
})
